// src/modules/auth/Logout.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';  // Use the AuthContext to trigger logout

const Logout = () => {
  const { logout } = useAuth();  // Get the logout function from context
  const navigate = useNavigate();  // For navigation

  useEffect(() => {
    logout();  // Trigger the logout function
    navigate('/login');  // Redirect to the login page after logging out
  }, [logout, navigate]);  // Only run this effect once on component mount

  return null;  // No UI needed, just performing the logout and redirect
};

export default Logout;
